import { ERROR_TYPES } from './constant/error-types.enum'
import lodash from 'lodash'
export class SDKError {
  constructor() {
    this.code = ERROR_TYPES.UNKNOWN.CODE
    this.name = ERROR_TYPES.UNKNOWN.NAME
    this.message = ERROR_TYPES.UNKNOWN.MESSAGE
    this.other = {}
  }

  invalidParameter(message=ERROR_TYPES.INVALID_PARAMETER.MESSAGE, other={}) {
    this.code = ERROR_TYPES.INVALID_PARAMETER.CODE
    this.name = ERROR_TYPES.INVALID_PARAMETER.NAME
    this.message = message
    this.other = other
    return this
  }

  failedAction(message=ERROR_TYPES.FAILED_ACTION.MESSAGE, code=ERROR_TYPES.FAILED_ACTION.CODE, name=ERROR_TYPES.FAILED_ACTION.NAME, other={}) {
    this.code = code
    this.name = name
    this.message = message
    this.other = other
    return this
  }

  serialize() {
    let result = {
      code: this.code,
      name: this.name,
      message: this.message
    }
    if (!lodash.isEmpty(this.other)) {
      result.other = this.other
    }

    return result
  }
}

export default {
  SDKError
}
